import type { networkConfigItemType } from "@/model/network";
import type Network from "@/model/network";

export const getNetworksFromTiers = (
  tiers: { name: string }[],
  lookup: Record<string, networkConfigItemType>,
): Network[] => {
  const uniqueSet = new Set(tiers.map((t) => t.name).filter(Boolean));
  const networks: Network[] = [];
  for (const [networkName, net] of Object.entries(lookup)) {
    if (uniqueSet.has(net.tier)) networks.push({ networkName, ...net });
  }
  networks.sort((a, b) => a.networkName.localeCompare(b.networkName));
  return networks;
};

export const getTiersFromNetworks = (
  networks: Array<Network>,
): { name: string }[] => {
  const tiers = Array.from(
    new Set(networks.map((n) => n.tier).filter(Boolean)),
  );
  tiers.sort();
  return tiers.map((name) => ({ name }));
};
